// removed by extract-text-webpack-plugin
module.exports = {"button":"-rQSBJEtP7yA9P77kVb1j","small":"_3CkVncJ7hsRohHeOmn15j8","normal":"_1OekmRUXo3HdXeDxdIgwWq","large":"_1Ry4K-UsZezM1zm_1iVEJI","primary":"_270kyF1zrzn2OCc2OGfgt1","invert":"_2sEXN5rDU9q4wiSVCiYAfR","disabled":"_1puxIOemqi_Ve3FayzwBT3","secondary":"_2qZPE7yT3HTQg9Xx04fw2f"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/Button/Button.css
// module id = 390
// module chunks = 0